module.exports = __webpack_public_path__ + "img/logo-horizontal-portariaja.36e32539.png";